import { CONTACT_STATUS } from "../../constants/admin/contact/contactConstants";

export const getStatusLabel = (status) => {
    switch (status) {
        case CONTACT_STATUS.PENDING:
            return "Chờ xử lý";

        case CONTACT_STATUS.IN_PROGRESS:
            return "Đang xử lý";

        case CONTACT_STATUS.RESOLVED:
            return "Đã xử lý";

        default:
            return status;
    }
};

export const getStatusBadgeClass = (status) => {
    switch (status) {
        case CONTACT_STATUS.PENDING:
            return "bg-yellow-500";

        case CONTACT_STATUS.IN_PROGRESS:
            return "bg-blue-500";

        case CONTACT_STATUS.RESOLVED:
            return "bg-green-500";

        default:
            return "bg-gray-500";
    }
};